import { urlsToMdLinks } from '@internal/utils/strings';

import { StyledReactMarkdown } from './markdown.styles';

interface MarkdownProps {
  value: string;
}

const Markdown = ({ value }: MarkdownProps) => {
  return (
    <StyledReactMarkdown>{urlsToMdLinks(value ?? '')}</StyledReactMarkdown>
  );
};

export default Markdown;
